/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';

import { GoogleFilePickerSkin } from '@gh/common-internal-shared';

@Component({
  selector: 'gh-google-drive-button',
  template: require('./google-drive-button.component.html'),
})
export class GoogleDriveButtonComponent {
  _url: string;
  _disableRipple: boolean = true;

  @Input() title: string = '';
  @Input() skin: GoogleFilePickerSkin = 'flat';

  @Input()
  set url(_url: string) {
    this._url = _url;
  }

  @Input()
  set disableRipple(_disableRipple: boolean) {
    this._disableRipple = _disableRipple;
  }
}
